
import { removeToken } from '@/utils/auth'
import { delParam } from '@/utils/index'
export function login (username, password) {
  // return request({
  //   url: '/user/login',
  //   //url: '/users/user/login',
  //   method: 'post',
  //   data: {
  //     username,
  //     password
  //   }
  // }
  let data = {
    'code': 20000,
    'data': {
      'token': 'admin'
    }
  }
  return new Promise(resolve => { resolve(data) })
}

export function getInfo (token) {
  // return request({
  //   url: '/user/info',
  //   method: 'get',
  //   params: { token }
  // })
  let data = {
    'code': 20000,
    'data': {
      'roles': ['admin'],
      'name': 'admin',
      'avatar': 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif'
    }
  }
  return new Promise(resolve => { resolve(data) })
}

export function logout () {
  let data = {
    'code': 20000,
    'data': {
    }
  }
  return new Promise(resolve => { resolve(data) })
}

export function reLogin () {
  removeToken()
  if (window.singleSpaNavigate) {
    window.location.href = '/'
    return
  }
  const state = window.btoa(Math.random() * 1000000000)
  const auth = process.env.VUE_APP_FORMFLOW_CAS
  const curUrl = delParam('token')
  const reloginUrl = `${auth}?redirect_uri=${encodeURIComponent(curUrl)}&state=${state}`
  window.location.href = reloginUrl
}
